import { createContext } from "react";

const MiscContext = createContext({ });

export default MiscContext;
